import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';
import { swiperOnResize } from '../../utils/swiperOnResize.utils.js';

let vacanciesSwiperWr = document.querySelectorAll('.vacancies-swiper-wr');
vacanciesSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let paginationEl = el.querySelector('.swiper-pagination');

    swiperOnResize('(max-width: 640px)', swiperEl,
        {
          modules: [Autoplay, Navigation, Pagination],
          slidesPerView: 1,
          spaceBetween: 16,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
        },
    );
  }
});